var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OverViewDepositEChart',{attrs:{"kerdar-lang":_vm.kerdarLang}}),_c('OverViewSuccessDepositEChart',{attrs:{"kerdar-lang":_vm.kerdarLang}}),_c('OverViewTurnOversEChartApiV2',{attrs:{"kerdar-lang":_vm.kerdarLang}}),_c('AllServiceAverageIncomeChart',{attrs:{"kerdar-lang":_vm.kerdarLang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }